import React, { useState, useEffect, useRef } from "react"

import { Row, Col, Card, CardBody, Alert } from "reactstrap"
import { Link } from "react-router-dom"

import profileImg from "../../assets/images/profile-img.png"
import LabelChargeData from "../../components/Common/labelChargeData"
//i18n
import { useTranslation } from "react-i18next"
//redux
import { useDispatch, useSelector } from "react-redux"
import { getFileRequirement } from "../../store/actions"

const PendingDocuments = ({ typeShowModal = false }) => {
  const { t } = useTranslation()
  const [avatar, setAvatar] = useState()
  const dispatch = useDispatch()

  const { loading, currentUser, listItems = [] } = useSelector(state => ({
    loading: state.Dashboard.loading,
    currentUser: state.Dashboard.user,
    listItems: state.Suppliers.fileRequirement
  }))

  useEffect(() => {
    if (currentUser)
      loadData()
  }, [currentUser])

  const loadData = async () => {
    if (currentUser.supplier) {
      await dispatch(getFileRequirement(currentUser.supplier.id))
    }
  }
  const listItem = listItems.map(item => {
    return item.status === 1 && (
      <li key={item.id} className="event-list active">
        <div className="event-timeline-dot">
          <i className="bx bxs-right-arrow-circle font-size-18  " />
        </div>
        <Row>
          <Col>
            <h5 className="font-size-14 text-primary">{item.fileName} </h5>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="flex-grow-1">
              <div>{item.updateFrequency}</div>
            </div>
          </Col>
        </Row>
      </li>
    )
  })

  const listItemsModal = listItems.map(item => (
    <Alert key={item.id} color="warning">
      <label className="text-primary">{item.fileName}</label>
      {": "}
      {item.updateFrequency}
    </Alert>
  ))

  return (
    <React.Fragment>
      {currentUser?.supplier && (<Card className="overflow-hidden">
        <div className="text-primary p-3">
          <h5 className="text-primary">{t("notificationSupplier:title")}</h5>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col>
              <LabelChargeData
                label={""}
                showloading={loading}
                title={t("global:loading")}
              />
            </Col>
          </Row>
          <Row>
            {typeShowModal && (<>{listItemsModal}</>)}
            {!typeShowModal && (<><ul className="verti-timeline list-unstyled">{listItem}</ul>
              <div className="text-center mt-4"></div></>)}
          </Row>
        </CardBody>
      </Card>)}
    </React.Fragment>
  )
}
export default PendingDocuments
